<template>
  <div class="modal olympic-modal fade" :id="id" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header modal-header-blue-bg">
          <div class="title-with-icon">
            <div class="title-with-icon__icon title-with-icon__icon-white title-with-icon__icon_exclamation"></div>
            <div class="title-with-icon__title">Подтверждение согласия</div>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="content_22 mb-4">
            Нажатием на кнопку "Продолжить" вы подтверждаете согласие с условиями регламента*!<br>
            <small class="text-muted">*С регламентом можно ознакомиться, скачав файл 
              <a href="https://exporteduru.servicecdn.ru/media/default/0003/47/a6503dccb4a2c366d18eab4a8d82a52d64de6100.pdf"
                 target="_blank" 
                 class="text-primary">
                "Регламент олимпиады.pdf"
              </a>
            </small>
          </p>
          <registration-form-condition v-model="aggree" />
          <div class="d-flex justify-content-between align-items-center mt-2">
            <button type="button" class="btn btn-md btn-secondary" @click="cancel">Отмена</button>
            <button type="button" :disabled="!aggree" class="btn btn-md btn-primary" @click="confirm">Продолжить</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
window.jQuery = $
import RegistrationFormCondition from "@/components/register/RegistrationFormCondition.vue";

export default {
  name: "OlympicsRegulationConfirmModal",
  components: {RegistrationFormCondition},
  props: {
    id: {
      type: String,
      default: 'olympics-regulation-confirm-modal'
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      aggree: false
    }
  },
  mounted() {
    let self = this
    $('#' + this.id).on('hide.bs.modal', function () {
      self.$emit('input', false)
    })
  },
  watch: {
    value: {
      handler: async function(val) {
        $('#' + this.id).modal(val ? 'show' : 'hide');
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
      this.$emit('input', false)
    },
    confirm() {
      this.$emit('confirm')
      this.$emit('input', false)
    }
  }
}
</script>

<style>
.modal-body {
  padding: 2rem 4rem;
}
.olympic-modal .checkbox input {
  width: 2.4rem!important;
  height: 100%;
}
</style>
